<template>
  <div>
    <h1>{{ $t('adminPanel.administration') }}</h1>
    <app-config />
    <patch-notes-editor
      class="open-patch-notes-editor-button"
      :mode="PatchNotesEditorMode.EDIT"
    />
    <docu-managers-table />
  </div>
</template>

<script lang="ts" setup>
  import PatchNotesEditor from '@/components/PatchNotesEditor/PatchNotesEditor.vue';
  import AppConfig from '../../components/AppConfig/AppConfig.vue';
  import DocuManagersTable from '../../components/DocuManagersTable/DocuManagersTable.vue';
  import { PatchNotesEditorMode } from '@/components/PatchNotesEditor/PatchNotesEditor.types';
</script>
<style lang="scss" scoped>
  h1 {
    font-size: 50px;
    font-weight: 700;
  }

  .spinner-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 300px;
  }

  .open-patch-notes-editor-button {
    margin-bottom: 1rem;
  }
</style>
